var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.title,"items":_vm.items,"editable":_vm.editable,"camposObgVisible":false}},[_c('div',{staticClass:"page-content"},[(!_vm.insertForm)?_c('DePara',{attrs:{"editable":_vm.editable}}):_vm._e(),(_vm.insertForm)?_c('DeParaNovo',{attrs:{"editable":_vm.editable}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }